import { Editor, Node, Element as SlateElement, Text, Transforms } from 'slate'
import { ReactEditor } from 'slate-react'

import { BLOCK_FORMATS, TCustomElement } from 'core-components/library/richTextEditor'

export const handleActionBlock = (
  editor: Editor,
  parentNode: TCustomElement,
  type: 'forward' | 'backward'
) => {
  const [actionBlock] = Editor.nodes(editor, {
    match: (node) => SlateElement.isElement(node) && node.type === BLOCK_FORMATS.action,
    mode: 'lowest',
  })

  // don't hande backward delete if this is thirst paragraph
  if (parentNode.type === BLOCK_FORMATS.paragraph && actionBlock) {
    const parentIsEmpty = Node.string(parentNode).trim().length === 0
    if (parentIsEmpty) {
      const path = ReactEditor.findPath(editor, actionBlock[0])
      Transforms.removeNodes(editor, { at: path })
    }
    if (type === 'backward' || isCursorAtEnd(editor)) {
      return true
    }
  }

  return false
}

const isCursorAtEnd = (editor: Editor): boolean => {
  if (!editor.selection) return false

  const { anchor } = editor.selection
  const [node] = Editor.node(editor, anchor.path)

  if (!Text.isText(node)) return false

  return anchor.offset === node.text.length
}
